module.exports = __webpack_public_path__ + "static/media/empty-survey-placeholder.eae6d3a7.svg";